//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList } from "@/mixins/index";
import addconsulting from "./components/addconsulting";
export default {
  name: "consultingList",
  mixins: [loadMoreList],
  components: {
    addconsulting: addconsulting
  },
  data: function data() {
    return {
      pagingReqFn: "businessInfo",
      pagingReqValue: "list"
    };
  },
  activated: function activated() {
    this.getList();
  },
  methods: {
    del: function del(data) {
      var _this = this;

      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'delBusinessInfo',
        data: {
          id: [data.id]
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};